import { render, staticRenderFns } from "./ReservationStats.vue?vue&type=template&id=6c24962a&"
import script from "./ReservationStats.vue?vue&type=script&lang=js&"
export * from "./ReservationStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c24962a')) {
      api.createRecord('6c24962a', component.options)
    } else {
      api.reload('6c24962a', component.options)
    }
    module.hot.accept("./ReservationStats.vue?vue&type=template&id=6c24962a&", function () {
      api.rerender('6c24962a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/ReservationStats.vue"
export default component.exports